import { Box, Typography, Link, Stack, useTheme, useMediaQuery } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      component="footer"
      sx={{
        py: 1.5,
        px: 2,
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        width: '100%'
      }}
    >
      <Stack 
        spacing={1}
        alignItems="center"
        width="100%"
      >
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          <Link
            component={RouterLink}
            to="/terms"
            color="text.secondary"
            variant="body2"
            sx={{ 
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline'
              }
            }}
          >
            Terms & Conditions
          </Link>

          <Link
            component={RouterLink}
            to="/privacy"
            color="text.secondary"
            variant="body2"
            sx={{ 
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline'
              }
            }}
          >
            Privacy Policy
          </Link>
        </Stack>

        <Typography 
          variant="body2" 
          color="text.secondary"
          align="center"
        >
          © {currentYear} Total Turf Experience. Powered by{' '}
          <Link
            href="https://mastrkeyllc.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ 
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline'
              }
            }}
          >
            MastrKey LLC
          </Link>
        </Typography>
      </Stack>
    </Box>
  );
};

export default Footer; 